import controller from './sliders.controller';
import template from './sliders.view.html';

let SlidersComponent = {
  template,
  controller,
  bindings : {
    dbData : '<',
    dbName : '<'
  }
};

export default SlidersComponent;



/** WEBPACK FOOTER **
 ** ./www/components/home/sliders/sliders.component.js
 **/